import { render, staticRenderFns } from "./IndividualCourseStudentLearningPanel.vue?vue&type=template&id=2ab4cb32&scoped=true"
import script from "./IndividualCourseStudentLearningPanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseStudentLearningPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualCourseStudentLearningPanel.vue?vue&type=style&index=0&id=2ab4cb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4cb32",
  null
  
)

export default component.exports